<div class="container mx-auto py-10">
  <!-- Header -->
  <div class="flex items-center justify-between space-y-2 mb-8">
    <div>
      <h2 class="text-3xl font-bold tracking-tight">Roles y Permisos</h2>
      <p class="text-muted-foreground">Gestión de roles RBAC, asignación de permisos y control de acceso del sistema</p>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TABS NAVIGATION                        -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading" class="mb-6">
    <div class="border-b border-gray-200">
      <nav class="flex space-x-6 overflow-x-auto">
        <button (click)="activeTab = 'dashboard'"
          [class]="activeTab === 'dashboard' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-chart-line mr-2"></i>Dashboard
        </button>
        <button (click)="activeTab = 'users'"
          [class]="activeTab === 'users' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-users mr-2"></i>Usuarios y Asignaciones
        </button>
        <button (click)="activeTab = 'departments'; loadDepartments()"
          [class]="activeTab === 'departments' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-building mr-2"></i>Catálogo de Departamentos
        </button>
        <button (click)="activeTab = 'roles'"
          [class]="activeTab === 'roles' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-shield-alt mr-2"></i>Catálogo de Roles
        </button>
        <button (click)="activeTab = 'permissions'"
          [class]="activeTab === 'permissions' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-key mr-2"></i>Matriz de Permisos
        </button>
        <button (click)="activeTab = 'audit'; loadAuditLogs()"
          [class]="activeTab === 'audit' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-history mr-2"></i>Auditoría
        </button>
        <!-- Solo quien puede editar Roles y Permisos: crea permisos nuevos desde la pantalla real -->
        <button *ngIf="mostrarHerramientasMatriz && puedeAgregarPermisos" (click)="activeTab = 'agregar'; agregarVisitada = true"
          [class]="activeTab === 'agregar' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-plus-circle mr-2"></i>Agregar permisos
          <span class="ml-1 inline-flex items-center rounded-full bg-green-100 px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-green-700">nuevo</span>
        </button>
        <!-- Renombrar y reordenar lo que ya existe (mismo permiso que Agregar permisos) -->
        <button *ngIf="mostrarHerramientasMatriz && puedeAgregarPermisos" (click)="activeTab = 'organizar'; organizarVisitada = true"
          [class]="activeTab === 'organizar' ? 'border-blue-500 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'"
          class="whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors">
          <i class="fas fa-sort mr-2"></i>Organizar la matriz
        </button>
      </nav>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB 1: DASHBOARD                       -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'dashboard'">
    <!-- Stats Cards -->
    <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-4 mb-8">
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
          <h3 class="tracking-tight text-sm font-medium">Roles Activos</h3>
          <i class="fas fa-shield-alt text-blue-500"></i>
        </div>
        <div class="p-6 pt-0">
          <div class="text-2xl font-bold text-blue-600">{{ stats.totalRoles }}</div>
          <p class="text-xs text-muted-foreground mt-1">Roles configurados en el sistema</p>
        </div>
      </div>
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
          <h3 class="tracking-tight text-sm font-medium">Módulos del Sistema</h3>
          <i class="fas fa-cubes text-purple-500"></i>
        </div>
        <div class="p-6 pt-0">
          <div class="text-2xl font-bold text-purple-600">{{ stats.totalModules }}</div>
          <p class="text-xs text-muted-foreground mt-1">Módulos protegidos por RBAC</p>
        </div>
      </div>
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
          <h3 class="tracking-tight text-sm font-medium">Submódulos</h3>
          <i class="fas fa-puzzle-piece text-green-500"></i>
        </div>
        <div class="p-6 pt-0">
          <div class="text-2xl font-bold text-green-600">{{ stats.totalSubmodules }}</div>
          <p class="text-xs text-muted-foreground mt-1">Submódulos controlados por permisos</p>
        </div>
      </div>
      <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
        <div class="p-6 flex flex-row items-center justify-between space-y-0 pb-2">
          <h3 class="tracking-tight text-sm font-medium">Usuarios RBAC</h3>
          <i class="fas fa-user-shield text-orange-500"></i>
        </div>
        <div class="p-6 pt-0">
          <div class="text-2xl font-bold">{{ stats.usersWithRbac }}<span class="text-sm font-normal text-muted-foreground"> / {{ stats.totalUsers }}</span></div>
          <p class="text-xs text-muted-foreground mt-1">{{ stats.usersWithoutRbac }} sin rol asignado</p>
        </div>
      </div>
    </div>

    <!-- Roles por departamento -->
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm mb-6">
      <div class="p-6">
        <h3 class="text-2xl font-semibold leading-none tracking-tight mb-4">
          <i class="fas fa-building mr-2 text-indigo-600"></i>Roles por Departamento
        </h3>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          <div *ngFor="let dept of getRolesByDepartment()" class="rounded-lg border p-4 hover:shadow-md transition-shadow">
            <div class="flex items-center gap-3 mb-3">
              <div class="w-3 h-3 rounded-full bg-gradient-to-r" [ngClass]="dept.color"></div>
              <h4 class="font-semibold">{{ dept.department }}</h4>
              <span class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold bg-gray-100 text-gray-700">{{ dept.roles.length }} rol{{ dept.roles.length !== 1 ? 'es' : '' }}</span>
            </div>
            <div class="space-y-1">
              <div *ngFor="let role of dept.roles" class="text-sm text-gray-600 flex items-center">
                <span><i class="fas fa-circle text-xs mr-2 text-gray-300"></i>{{ role.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Info de fases -->
    <div class="bg-blue-50 border-l-4 border-blue-500 p-4 rounded-r-lg">
      <div class="flex items-start">
        <i class="fas fa-info-circle text-blue-500 mt-1 mr-3"></i>
        <div>
          <h3 class="font-semibold text-blue-900 mb-1">Sistema RBAC Configurable</h3>
          <p class="text-blue-700 text-sm">Este módulo permite gestionar roles, permisos y auditoría del sistema de control de acceso basado en roles (RBAC). Los permisos se configuran por módulo, submódulo y acción para cada rol del sistema.</p>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB 2: USUARIOS Y ASIGNACIONES         -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'users'">
    <!-- Activos / Inactivos toggle + Crear Usuario -->
    <div class="flex items-center justify-between mb-4">
      <div class="flex items-center gap-1 bg-gray-100 rounded-lg p-1">
        <button (click)="switchStatus('active')"
          class="px-4 py-2 rounded-md text-sm font-medium transition-colors"
          [ngClass]="statusFilter === 'active' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
          <i class="fas fa-check-circle mr-1.5 text-green-500" *ngIf="statusFilter === 'active'"></i>Activos
        </button>
        <button (click)="switchStatus('inactive')"
          class="px-4 py-2 rounded-md text-sm font-medium transition-colors"
          [ngClass]="statusFilter === 'inactive' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
          <i class="fas fa-ban mr-1.5 text-red-500" *ngIf="statusFilter === 'inactive'"></i>Inactivos
        </button>
      </div>
      <button (click)="openCreateUserModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-green-600 text-white hover:bg-green-700 h-10 px-4 py-2 transition-colors">
        <i class="fas fa-user-plus mr-2"></i>Nuevo Usuario
      </button>
    </div>

    <!-- Search -->
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm mb-4">
      <div class="p-4">
        <div class="flex flex-col md:flex-row items-stretch md:items-center gap-3">
          <div class="flex-1 relative">
            <input type="text" [(ngModel)]="searchTerm" (input)="onSearchInput()"
              placeholder="Buscar por nombre, usuario, correo o teléfono..."
              class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 pr-10 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2">
            <i class="fas fa-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm"></i>
          </div>
          <button *ngIf="searchTerm" (click)="clearSearch()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2">
            <i class="fas fa-times mr-2"></i>Limpiar
          </button>
        </div>
      </div>
    </div>

    <!-- Filtros -->
    <div class="flex flex-wrap items-center gap-3 mb-4">
      <select [(ngModel)]="filterRole" (change)="onFilterChange()"
        class="h-9 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
        <option value="">Todos los roles</option>
        <option *ngFor="let role of roles" [value]="role.code">{{ role.name }}</option>
      </select>
      <select [(ngModel)]="filterDepartment" (change)="onFilterChange()"
        class="h-9 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
        <option value="">Todos los departamentos</option>
        <option *ngFor="let dept of uniqueDepartments" [value]="dept">{{ dept }}</option>
      </select>
      <button *ngIf="filterRole || filterDepartment" (click)="clearFilters()"
        class="inline-flex items-center text-xs text-gray-500 hover:text-gray-700 cursor-pointer">
        <i class="fas fa-times mr-1"></i>Limpiar filtros
      </button>
      <span class="ml-auto text-sm text-gray-500">{{ usersTotal }} usuario{{ usersTotal !== 1 ? 's' : '' }}</span>
    </div>

    <!-- Users Table -->
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="relative w-full overflow-auto">
        <!-- Loading overlay -->
        <div *ngIf="loadingUsers" class="absolute inset-0 bg-white/70 z-10 flex items-center justify-center">
          <div class="text-center">
            <i class="fas fa-spinner fa-spin text-2xl text-blue-500"></i>
            <p class="mt-2 text-sm text-gray-500">Cargando usuarios...</p>
          </div>
        </div>
        <table class="w-full caption-bottom text-sm">
          <thead class="border-b">
            <tr class="border-b transition-colors bg-muted/30">
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground cursor-pointer select-none hover:text-gray-900"
                  (click)="sortUsersBy('username')" title="Ordenar por usuario">
                <span class="inline-flex items-center gap-1">Usuario
                  <i class="fas text-xs"
                     [class.fa-sort]="usersSortColumn !== 'username'"
                     [class.fa-sort-up]="usersSortColumn === 'username' && usersSortDirection === 'asc'"
                     [class.fa-sort-down]="usersSortColumn === 'username' && usersSortDirection === 'desc'"
                     [class.text-gray-300]="usersSortColumn !== 'username'"
                     [class.text-blue-600]="usersSortColumn === 'username'"></i>
                </span>
              </th>
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground cursor-pointer select-none hover:text-gray-900"
                  (click)="sortUsersBy('name')" title="Ordenar por nombre">
                <span class="inline-flex items-center gap-1">Nombre
                  <i class="fas text-xs"
                     [class.fa-sort]="usersSortColumn !== 'name'"
                     [class.fa-sort-up]="usersSortColumn === 'name' && usersSortDirection === 'asc'"
                     [class.fa-sort-down]="usersSortColumn === 'name' && usersSortDirection === 'desc'"
                     [class.text-gray-300]="usersSortColumn !== 'name'"
                     [class.text-blue-600]="usersSortColumn === 'name'"></i>
                </span>
              </th>
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground hidden md:table-cell cursor-pointer select-none hover:text-gray-900"
                  (click)="sortUsersBy('email')" title="Ordenar por correo">
                <span class="inline-flex items-center gap-1">Correo
                  <i class="fas text-xs"
                     [class.fa-sort]="usersSortColumn !== 'email'"
                     [class.fa-sort-up]="usersSortColumn === 'email' && usersSortDirection === 'asc'"
                     [class.fa-sort-down]="usersSortColumn === 'email' && usersSortDirection === 'desc'"
                     [class.text-gray-300]="usersSortColumn !== 'email'"
                     [class.text-blue-600]="usersSortColumn === 'email'"></i>
                </span>
              </th>
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground hidden lg:table-cell">Teléfono</th>
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground cursor-pointer select-none hover:text-gray-900"
                  (click)="sortUsersBy('role')" title="Ordenar por rol">
                <span class="inline-flex items-center gap-1">Rol RBAC
                  <i class="fas text-xs"
                     [class.fa-sort]="usersSortColumn !== 'role'"
                     [class.fa-sort-up]="usersSortColumn === 'role' && usersSortDirection === 'asc'"
                     [class.fa-sort-down]="usersSortColumn === 'role' && usersSortDirection === 'desc'"
                     [class.text-gray-300]="usersSortColumn !== 'role'"
                     [class.text-blue-600]="usersSortColumn === 'role'"></i>
                </span>
              </th>
              <th class="h-11 px-4 text-left align-middle font-medium text-muted-foreground hidden xl:table-cell">Tienda</th>
              <th class="h-11 px-4 text-right align-middle font-medium text-muted-foreground">Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let user of sortedUsers" class="border-b transition-colors hover:bg-muted/50">
              <td class="p-3 align-middle cursor-pointer" (click)="openUserDetailModal(user)">
                <div class="font-medium text-sm text-blue-600 hover:underline">{{ user.username }}</div>
              </td>
              <td class="p-3 align-middle cursor-pointer" (click)="openUserDetailModal(user)">
                <span class="text-capitalize text-sm">{{ user.name }} {{ user.lastName }}</span>
              </td>
              <td class="p-3 align-middle hidden md:table-cell">
                <span *ngIf="user.email" class="text-xs text-gray-600">{{ user.email }}</span>
                <span *ngIf="!user.email" class="text-xs text-gray-400">—</span>
              </td>
              <td class="p-3 align-middle hidden lg:table-cell">
                <span *ngIf="user.phone" class="text-xs text-gray-600">{{ user.phone }}</span>
                <span *ngIf="!user.phone" class="text-xs text-gray-400">—</span>
              </td>
              <td class="p-3 align-middle">
                <div class="flex flex-wrap gap-1" *ngIf="user.rbacRoles?.length > 0">
                  <span *ngFor="let role of user.rbacRoles; let i = index"
                    class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold"
                    [ngClass]="getDepartmentColor(role.department)">
                    {{ role.name }}
                  </span>
                </div>
                <span *ngIf="!user.rbacRoles?.length" class="text-xs text-gray-400 italic">Sin asignar</span>
              </td>
              <td class="p-3 align-middle hidden xl:table-cell">
                <span *ngIf="user.shop" class="text-xs text-gray-600">{{ getShopName(user.shop) }}</span>
                <span *ngIf="!user.shop" class="text-xs text-gray-400">—</span>
              </td>
              <td class="p-3 align-middle text-right">
                <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')"
                  (click)="toggleActionsMenu(user, $event); $event.stopPropagation()"
                  class="inline-flex items-center justify-center rounded-md text-xs font-medium border border-gray-200 bg-white hover:bg-gray-50 h-8 w-8 transition-colors shadow-sm">
                  <i class="fas fa-ellipsis-v text-gray-500"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div *ngIf="!loadingUsers && users.length === 0" class="p-8 text-center text-gray-400">
        <i class="fas fa-users text-3xl mb-2"></i>
        <p class="text-sm">No se encontraron usuarios</p>
      </div>

      <!-- Paginación -->
      <div *ngIf="usersTotalPages > 1" class="flex items-center justify-between px-4 py-3 border-t">
        <div class="text-xs text-gray-500">
          Página {{ usersPage }} de {{ usersTotalPages }}
        </div>
        <div class="flex items-center gap-1">
          <button (click)="goToPage(1)" [disabled]="usersPage === 1"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-double-left"></i>
          </button>
          <button (click)="goToPage(usersPage - 1)" [disabled]="usersPage === 1"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-left"></i>
          </button>
          <button *ngFor="let p of getPageNumbers()" (click)="goToPage(p)"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border transition-colors"
            [ngClass]="p === usersPage ? 'bg-primary text-primary-foreground border-primary' : 'border-input bg-background hover:bg-accent'">
            {{ p }}
          </button>
          <button (click)="goToPage(usersPage + 1)" [disabled]="usersPage === usersTotalPages"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-right"></i>
          </button>
          <button (click)="goToPage(usersTotalPages)" [disabled]="usersPage === usersTotalPages"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-double-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB: CATÁLOGO DE DEPARTAMENTOS          -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'departments'">
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6">
        <div class="flex items-center justify-between mb-6">
          <div>
            <h3 class="text-lg font-semibold"><i class="fas fa-building mr-2 text-indigo-600"></i>Catálogo de Departamentos</h3>
            <p class="text-sm text-gray-500 mt-1">Gestiona los departamentos disponibles para asignar a roles RBAC</p>
          </div>
          <button type="button" (click)="showCreateDeptModal = true"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 transition-colors whitespace-nowrap">
            <i class="fas fa-plus mr-2"></i>Crear Departamento
          </button>
        </div>

        <!-- Loading -->
        <div *ngIf="loadingDepartments" class="py-8 text-center">
          <i class="fas fa-spinner fa-spin text-2xl text-gray-400"></i>
          <p class="mt-2 text-sm text-gray-500">Cargando departamentos...</p>
        </div>

        <!-- Lista de departamentos (accordion) -->
        <div *ngIf="!loadingDepartments" class="space-y-2">
          <div *ngFor="let dept of departmentsList" class="rounded-lg border overflow-hidden">
            <!-- Header del departamento (clickeable para expandir) -->
            <div class="flex items-center justify-between p-4 cursor-pointer hover:bg-muted/50 transition-colors"
              (click)="dept._expanded = !dept._expanded">
              <div class="flex items-center gap-3">
                <div class="w-10 h-10 rounded-full bg-indigo-100 flex items-center justify-center">
                  <i class="fas fa-building text-indigo-600"></i>
                </div>
                <div>
                  <p class="font-medium text-sm">{{ dept.name }}</p>
                  <p class="text-xs text-gray-500">
                    {{ dept.rolesCount }} rol{{ dept.rolesCount !== 1 ? 'es' : '' }} asignado{{ dept.rolesCount !== 1 ? 's' : '' }}
                  </p>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <span *ngIf="dept.rolesCount > 0"
                  class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-blue-100 text-blue-700">
                  En uso
                </span>
                <button *ngIf="dept.rolesCount === 0" type="button" (click)="onDeleteDepartment(dept); $event.stopPropagation()"
                  [disabled]="deletingDepartment === dept.name"
                  class="inline-flex items-center justify-center rounded-md text-xs font-medium border border-red-200 text-red-600 hover:bg-red-50 h-8 px-3 transition-colors">
                  <i class="fas fa-trash mr-1" *ngIf="deletingDepartment !== dept.name"></i>
                  <i class="fas fa-spinner fa-spin mr-1" *ngIf="deletingDepartment === dept.name"></i>
                  Eliminar
                </button>
                <i class="fas fa-chevron-down text-gray-400 text-xs transition-transform ml-2"
                  [ngClass]="{'rotate-180': dept._expanded}"></i>
              </div>
            </div>
            <!-- Roles del departamento (expandible) -->
            <div *ngIf="dept._expanded" class="border-t bg-gray-50 px-4 py-3">
              <div class="flex items-center justify-between mb-2">
                <p class="text-xs font-medium text-gray-500">Roles en este departamento:</p>
                <button type="button" (click)="openAssignRoleToDeptModal(dept); $event.stopPropagation()"
                  class="inline-flex items-center text-xs font-medium text-indigo-600 hover:text-indigo-800 px-2 py-1 rounded hover:bg-indigo-50 transition-colors">
                  <i class="fas fa-plus mr-1"></i>Asignar Rol
                </button>
              </div>
              <div *ngIf="dept.roles?.length > 0" class="space-y-1.5">
                <div *ngFor="let role of dept.roles"
                  class="flex items-center justify-between px-3 py-2 bg-white rounded-md border text-sm">
                  <div class="flex items-center gap-2">
                    <i class="fas fa-shield-alt text-indigo-400 text-xs"></i>
                    <span class="font-medium">{{ role.name }}</span>
                    <span class="text-xs text-gray-400 font-mono">{{ role.code }}</span>
                  </div>
                  <div class="flex items-center gap-3">
                    <button type="button" (click)="removeRoleFromDept(role.code, dept.name); $event.stopPropagation()"
                      class="text-red-400 hover:text-red-600 text-xs transition-colors" title="Desasignar del departamento">
                      <i class="fas fa-times"></i>
                    </button>
                  </div>
                </div>
              </div>
              <div *ngIf="dept.roles?.length === 0" class="py-3 text-center">
                <p class="text-xs text-gray-400"><i class="fas fa-info-circle mr-1"></i>Sin roles asignados a este departamento</p>
              </div>
            </div>
          </div>
          <div *ngIf="departmentsList.length === 0" class="py-8 text-center text-gray-400">
            <i class="fas fa-building text-3xl mb-2"></i>
            <p class="text-sm">No hay departamentos registrados</p>
            <p class="text-xs mt-1">Crea un departamento para poder asignarlo a roles</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Crear Departamento               -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showCreateDeptModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeCreateDeptModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-building mr-2 text-indigo-600"></i>Crear Departamento</h3>
          <button (click)="closeCreateDeptModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="mb-4">
          <label class="text-sm font-medium leading-none mb-2 block">Nombre del departamento</label>
          <input type="text" #createDeptInput
            [value]="newDepartmentName"
            (input)="newDepartmentName = createDeptInput.value"
            (keyup.enter)="createDepartment()"
            placeholder="Ej: Recursos Humanos"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
        </div>
        <div class="flex gap-2 justify-end">
          <button type="button" (click)="closeCreateDeptModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button type="button" (click)="createDepartment()" [disabled]="savingDepartment"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 disabled:opacity-50 transition-colors">
            <i class="fas fa-plus mr-2" *ngIf="!savingDepartment"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingDepartment"></i>
            Crear
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Asignar Rol a Departamento       -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showAssignRoleToDeptModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeAssignRoleToDeptModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-link mr-2 text-indigo-600"></i>Asignar Rol</h3>
          <button (click)="closeAssignRoleToDeptModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <p class="text-sm text-gray-500 mb-4">Asignar un rol al departamento <strong>{{ assignRoleToDeptTarget?.name }}</strong></p>
        <div class="mb-4">
          <label class="text-sm font-medium leading-none mb-2 block">Seleccionar rol</label>
          <select [(ngModel)]="assignRoleToDeptCode"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="">-- Seleccionar rol --</option>
            <option *ngFor="let role of getRolesNotInDept(assignRoleToDeptTarget)" [value]="role.code">
              {{ role.name }} ({{ role.department || 'Sin departamento' }})
            </option>
          </select>
          <p class="text-xs text-gray-400 mt-1">Si el rol ya pertenece a otro departamento, será reasignado.</p>
        </div>
        <div class="flex gap-2 justify-end">
          <button type="button" (click)="closeAssignRoleToDeptModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button type="button" (click)="assignRoleToDept()" [disabled]="!assignRoleToDeptCode || savingDepartment"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 h-10 px-4 py-2 disabled:opacity-50 transition-colors">
            <i class="fas fa-link mr-2" *ngIf="!savingDepartment"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingDepartment"></i>
            Asignar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Usuarios de un Rol               -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showRoleUsersModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeRoleUsersModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 z-10 max-h-[80vh] overflow-y-auto">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-users mr-2 text-blue-600"></i>Usuarios del Rol</h3>
          <button (click)="closeRoleUsersModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>
        <div class="mb-4 p-3 rounded-lg bg-blue-50">
          <p class="text-sm font-medium">{{ roleUsersData?.name }}</p>
          <p class="text-xs text-gray-500">{{ roleUsersData?.code }} — {{ roleUsersData?.department }}</p>
        </div>

        <div *ngIf="loadingRoleUsers" class="py-6 text-center">
          <i class="fas fa-spinner fa-spin text-2xl text-gray-400"></i>
          <p class="text-sm text-gray-500 mt-2">Cargando usuarios...</p>
        </div>

        <div *ngIf="!loadingRoleUsers && roleUsersList.length > 0" class="space-y-2">
          <div *ngFor="let user of roleUsersList"
            class="flex items-center justify-between p-3 rounded-lg border hover:bg-muted/50">
            <div class="flex items-center gap-3">
              <div class="w-8 h-8 rounded-full bg-blue-100 flex items-center justify-center text-xs font-bold text-blue-700">
                {{ (user.name || '?')[0] | uppercase }}{{ (user.lastName || '?')[0] | uppercase }}
              </div>
              <div>
                <p class="text-sm font-medium text-capitalize">{{ user.name }} {{ user.lastName }}</p>
                <p class="text-xs text-gray-500">{{ user.username }}</p>
              </div>
            </div>
          </div>
        </div>

        <div *ngIf="!loadingRoleUsers && roleUsersList.length === 0" class="py-6 text-center text-gray-400">
          <i class="fas fa-users text-2xl mb-2"></i>
          <p class="text-sm">No hay usuarios asignados a este rol</p>
        </div>

        <div class="flex justify-end pt-4 mt-4 border-t">
          <button type="button" (click)="closeRoleUsersModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB: CATÁLOGO DE ROLES                 -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'roles'">
    <!-- Botón crear rol -->
    <div class="flex justify-end mb-4">
      <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="openCreateRoleModal()"
        class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 transition-colors">
        <i class="fas fa-plus mr-2"></i>Crear Nuevo Rol
      </button>
    </div>
    <div class="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
      <div *ngFor="let role of roles"
        class="rounded-lg border bg-card text-card-foreground shadow-sm hover:shadow-md transition-shadow cursor-pointer"
        (click)="openPermissionsModal(role)">
        <div class="p-6">
          <div class="flex items-center justify-between mb-3">
            <span class="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold"
              [ngClass]="getDepartmentColor(role.department)">
              {{ role.department }}
            </span>
          </div>
          <h3 class="text-lg font-semibold mb-1">{{ role.name }}</h3>
          <p class="text-sm text-gray-500 mb-3">{{ role.description }}</p>
          <div class="flex items-center justify-between">
            <span class="text-xs text-gray-400">
              <i class="fas fa-code mr-1"></i>{{ role.code }}
            </span>
            <span class="inline-flex items-center text-xs cursor-pointer hover:underline"
              [ngClass]="role.usersCount > 0 ? 'text-blue-600 font-medium' : 'text-gray-500'"
              (click)="openRoleUsersModal(role, $event)">
              <i class="fas fa-users mr-1"></i>{{ role.usersCount }} usuario{{ role.usersCount !== 1 ? 's' : '' }}
            </span>
          </div>
          <div class="mt-3 pt-3 border-t flex items-center justify-end">
            <div class="flex items-center gap-2">
              <span class="text-xs text-blue-600 font-medium cursor-pointer" (click)="openPermissionsModal(role); $event.stopPropagation()">
                <i class="fas fa-eye mr-1"></i>Ver permisos
              </span>
              <button data-rbac-permiso="config.roles_permisos.update" *ngIf="!role.isSystemRole && role.usersCount === 0 && _auth.hasPermission('config.roles_permisos.update')"
                (click)="deleteRole(role); $event.stopPropagation()"
                class="text-xs text-red-500 hover:text-red-700 px-1.5 py-0.5 rounded hover:bg-red-50 transition-colors"
                title="Eliminar rol">
                <i class="fas fa-trash"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="roles.length === 0" class="py-12 text-center text-gray-400">
      <i class="fas fa-shield-alt text-4xl mb-3"></i>
      <p>No hay roles RBAC configurados en el sistema.</p>
      <p class="text-xs mt-1">Ejecuta el seed de roles para inicializar el sistema RBAC.</p>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB 4: MATRIZ DE PERMISOS              -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'permissions'">
    <!-- Selector de rol -->
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm mb-6">
      <div class="p-6">
        <div class="flex flex-col md:flex-row items-start md:items-center gap-4">
          <h3 class="text-lg font-semibold whitespace-nowrap">
            <i class="fas fa-key mr-2 text-indigo-600"></i>Configurar Permisos para:
          </h3>
          <select [(ngModel)]="selectedRoleForMatrix" (change)="onRoleSelectForMatrix()"
            class="flex h-10 w-full md:w-96 rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="">-- Seleccione un rol --</option>
            <option *ngFor="let role of roles" [value]="role.code">
              {{ role.name }} ({{ role.department }})
            </option>
          </select>
          <!-- Solo fuera de producción: no se renderiza en prod -->
          <div *ngIf="!esProduccion && selectedRoleForMatrix && !loadingMatrix" class="flex items-center gap-2 md:ml-auto">
            <button (click)="confirmarAccesoMatriz(true)" [disabled]="savingMatrix"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-indigo-600 text-white hover:bg-indigo-700 h-9 px-4 disabled:opacity-50 transition-colors">
              <i class="fas fa-check-double mr-2"></i>Acceso completo
            </button>
            <button (click)="confirmarAccesoMatriz(false)" [disabled]="savingMatrix"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50 h-9 px-4 disabled:opacity-50 transition-colors">
              <i class="fas fa-eraser mr-2"></i>Quitar todos
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Leyenda -->
    <div *ngIf="selectedRoleForMatrix" class="flex flex-wrap items-center gap-4 mb-4 p-3 rounded-lg bg-gray-50 border">
      <span class="text-xs font-semibold text-gray-500 uppercase">Leyenda:</span>
      <span class="inline-flex items-center gap-1 text-xs"><span class="w-3 h-3 rounded-full bg-green-500"></span> Acceso completo</span>
      <span class="inline-flex items-center gap-1 text-xs"><span class="w-3 h-3 rounded-full bg-yellow-500"></span> Acceso parcial</span>
      <span class="inline-flex items-center gap-1 text-xs"><span class="w-3 h-3 rounded-full bg-red-500"></span> Denegado</span>
    </div>

    <!-- Loading state -->
    <div *ngIf="loadingMatrix" class="py-12 text-center">
      <i class="fas fa-spinner fa-spin text-3xl text-blue-500 mb-3"></i>
      <p class="text-gray-500">Cargando permisos de <strong>{{ selectedRoleForMatrix }}</strong> desde la base de datos...</p>
    </div>

    <!-- Error del catálogo (la matriz sale del API, no hay lista local de respaldo) -->
    <div *ngIf="catalogoError && !loadingMatrix" class="py-6 text-center text-red-600">
      <i class="fas fa-exclamation-triangle mr-2"></i>No se pudo cargar el catálogo de permisos
      <button (click)="recargarCatalogo()" class="ml-3 underline">Reintentar</button>
    </div>

    <!-- Matriz de permisos: Módulos → Submódulos → Acciones -->
    <div *ngIf="selectedRoleForMatrix && !loadingMatrix" class="space-y-3">
      <div *ngFor="let entry of permissionsMatrix; let mi = index"
        class="rounded-lg border bg-card text-card-foreground shadow-sm overflow-hidden">
        <!-- Module header (collapsible) -->
        <div class="cursor-pointer p-4 flex items-center justify-between transition-colors"
          [class]="isModuleExpanded(entry.module.id) ? 'bg-blue-50' : 'hover:bg-muted/50'">
          <div class="flex items-center gap-3" (click)="toggleModuleExpand(entry.module.id)">
            <i [class]="entry.module.icon + ' text-lg'" [class.text-blue-600]="isModuleExpanded(entry.module.id)" [class.text-gray-500]="!isModuleExpanded(entry.module.id)"></i>
            <span class="font-semibold">{{ entry.module.name }}</span>
            <!-- Status badge -->
            <span *ngIf="entry.moduleStatus === 'all'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-green-100 text-green-800">
              <i class="fas fa-check-circle mr-1"></i>Acceso completo
            </span>
            <span *ngIf="entry.moduleStatus === 'denied'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-red-100 text-red-800">
              <i class="fas fa-ban mr-1"></i>DENEGADO
            </span>
            <span *ngIf="entry.moduleStatus === 'partial'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-800">
              <i class="fas fa-adjust mr-1"></i>{{ getEnabledSubmodulesCount(entry) }}/{{ getTotalSubmodulesCount(entry) }} submódulos
            </span>
          </div>
          <div class="flex items-center gap-3">
            <!-- Module toggle switch -->
            <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="toggleModule(mi); $event.stopPropagation()"
              class="relative inline-flex h-6 w-11 items-center rounded-full transition-colors"
              [class]="entry.moduleStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'"
              title="Activar/desactivar módulo completo">
              <span class="inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform"
                [class]="entry.moduleStatus !== 'denied' ? 'translate-x-6' : 'translate-x-1'"></span>
            </button>
            <div *ngIf="!_auth.hasPermission('config.roles_permisos.update')" class="w-11 h-6 bg-gray-200 rounded-full flex items-center px-1">
              <span class="inline-block h-4 w-4 rounded-full bg-gray-400 shadow-sm"
                [class]="entry.moduleStatus !== 'denied' ? 'translate-x-5' : ''"></span>
            </div>
            <i (click)="toggleModuleExpand(entry.module.id)" class="fas fa-chevron-down transition-transform text-gray-400" [class.rotate-180]="isModuleExpanded(entry.module.id)"></i>
          </div>
        </div>

        <!-- Module content: Submodules list -->
        <div *ngIf="isModuleExpanded(entry.module.id)" class="border-t">
          <!-- Direct submodules -->
          <div *ngFor="let sub of entry.submodules; let si = index"
            [attr.id]="'fila-' + (sub.moduleId || entry.module.id) + '|' + sub.id"
            [class.ring-2]="filaResaltada === (sub.moduleId || entry.module.id) + '|' + sub.id"
            [class.ring-amber-400]="filaResaltada === (sub.moduleId || entry.module.id) + '|' + sub.id"
            [class.ring-inset]="true"
            class="border-b last:border-b-0 px-6 py-4"
            [class]="sub.subStatus === 'denied' ? 'bg-red-50/50' : (sub.subStatus === 'all' ? 'bg-green-50/30' : 'bg-white')">
            <div class="flex items-center justify-between mb-2">
              <div class="flex items-center gap-2">
                <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="toggleSubmodule(mi, si)"
                  class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors flex-shrink-0"
                  [class]="sub.subStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'"
                  title="Activar/desactivar submódulo">
                  <span class="inline-block h-3 w-3 transform rounded-full bg-white shadow-sm transition-transform"
                    [class]="sub.subStatus !== 'denied' ? 'translate-x-5' : 'translate-x-1'"></span>
                </button>
                <div *ngIf="!_auth.hasPermission('config.roles_permisos.update')" class="w-9 h-5 bg-gray-200 rounded-full flex items-center px-0.5">
                  <span class="inline-block h-3 w-3 rounded-full bg-gray-400 shadow-sm"
                    [class]="sub.subStatus !== 'denied' ? 'translate-x-5' : ''"></span>
                </div>
                <span class="text-sm font-medium" [class.text-gray-400]="sub.subStatus === 'denied'" [class.line-through]="sub.subStatus === 'denied'">{{ sub.name }}</span>
                <span *ngIf="sub.subStatus === 'denied'" class="text-xs text-red-600 font-semibold">(DENEGADO)</span>
              </div>
              <span *ngIf="sub.subStatus !== 'denied'" class="text-xs text-gray-500">
                {{ getEnabledActionsInSub(sub) }}/{{ sub.actions.length }} acciones
              </span>
            </div>
            <div *ngIf="sub.subStatus !== 'denied'" class="flex flex-wrap gap-2 ml-11">
              <div *ngFor="let action of sub.actions; let ai = index"
                (click)="_auth.hasPermission('config.roles_permisos.update') && toggleSubPermission(mi, si, ai)"
                class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium transition-all border"
                [class]="action.enabled
                  ? 'border-green-300 bg-green-50 text-green-800 ' + (_auth.hasPermission('config.roles_permisos.update') ? 'cursor-pointer hover:bg-green-100' : 'cursor-not-allowed')
                  : 'border-gray-200 bg-gray-50 text-gray-400 line-through ' + (_auth.hasPermission('config.roles_permisos.update') ? 'cursor-pointer hover:bg-gray-100' : 'cursor-not-allowed')">
                <i [class]="action.icon" class="text-[10px]"></i>
                {{ action.name }}
              </div>
            </div>
            <div *ngIf="sub.subStatus === 'denied'" class="flex flex-wrap gap-2 ml-11 opacity-40">
              <div *ngFor="let action of sub.actions"
                class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border border-gray-200 bg-gray-50 text-gray-400 line-through">
                <i [class]="action.icon" class="text-[10px]"></i>
                {{ action.name }}
              </div>
            </div>
          </div>

          <!-- Sections (grouped submodules) -->
          <div *ngFor="let sec of entry.sections; let secIdx = index" class="border-b last:border-b-0">
            <!-- Section header -->
            <div class="cursor-pointer px-6 py-3 flex items-center justify-between transition-colors border-t"
              [class]="isSectionExpanded(sec.id) ? 'bg-indigo-50' : 'bg-gray-50 hover:bg-gray-100'">
              <div class="flex items-center gap-3" (click)="toggleSectionExpand(sec.id)">
                <i [class]="sec.icon + ' text-sm'" [class.text-indigo-600]="isSectionExpanded(sec.id)" [class.text-gray-500]="!isSectionExpanded(sec.id)"></i>
                <span class="font-semibold text-sm">{{ sec.name }}</span>
                <span *ngIf="sec.sectionStatus === 'all'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-green-100 text-green-800">
                  <i class="fas fa-check-circle mr-1"></i>Acceso completo
                </span>
                <span *ngIf="sec.sectionStatus === 'denied'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-red-100 text-red-800">
                  <i class="fas fa-ban mr-1"></i>DENEGADO
                </span>
                <span *ngIf="sec.sectionStatus === 'partial'" class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium bg-yellow-100 text-yellow-800">
                  <i class="fas fa-adjust mr-1"></i>{{ getEnabledSectionSubmodulesCount(sec) }}/{{ sec.submodules.length }} submódulos
                </span>
              </div>
              <div class="flex items-center gap-3">
                <button (click)="toggleSection(mi, secIdx); $event.stopPropagation()"
                  class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors flex-shrink-0"
                  [class]="sec.sectionStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'"
                  title="Activar/desactivar sección completa">
                  <span class="inline-block h-3 w-3 transform rounded-full bg-white shadow-sm transition-transform"
                    [class]="sec.sectionStatus !== 'denied' ? 'translate-x-5' : 'translate-x-1'"></span>
                </button>
                <i (click)="toggleSectionExpand(sec.id)" class="fas fa-chevron-down transition-transform text-gray-400 text-xs" [class.rotate-180]="isSectionExpanded(sec.id)"></i>
              </div>
            </div>
            <!-- Section submodules -->
            <div *ngIf="isSectionExpanded(sec.id)">
              <div *ngFor="let sub of sec.submodules; let si = index"
                [attr.id]="'fila-' + (sub.moduleId || sec.moduleId) + '|' + sub.id"
                [class.ring-2]="filaResaltada === (sub.moduleId || sec.moduleId) + '|' + sub.id"
                [class.ring-amber-400]="filaResaltada === (sub.moduleId || sec.moduleId) + '|' + sub.id"
                [class.ring-inset]="true"
                class="border-b last:border-b-0 px-8 py-4"
                [class]="sub.subStatus === 'denied' ? 'bg-red-50/50' : (sub.subStatus === 'all' ? 'bg-green-50/30' : 'bg-white')">
                <div class="flex items-center justify-between mb-2">
                  <div class="flex items-center gap-2">
                    <button (click)="toggleSectionSubmodule(mi, secIdx, si)"
                      class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors flex-shrink-0"
                      [class]="sub.subStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'"
                      title="Activar/desactivar submódulo">
                      <span class="inline-block h-3 w-3 transform rounded-full bg-white shadow-sm transition-transform"
                        [class]="sub.subStatus !== 'denied' ? 'translate-x-5' : 'translate-x-1'"></span>
                    </button>
                    <span class="text-sm font-medium" [class.text-gray-400]="sub.subStatus === 'denied'" [class.line-through]="sub.subStatus === 'denied'">{{ sub.name }}</span>
                    <span *ngIf="sub.subStatus === 'denied'" class="text-xs text-red-600 font-semibold">(DENEGADO)</span>
                  </div>
                  <span *ngIf="sub.subStatus !== 'denied'" class="text-xs text-gray-500">
                    {{ getEnabledActionsInSub(sub) }}/{{ sub.actions.length }} acciones
                  </span>
                </div>
                <div *ngIf="sub.subStatus !== 'denied'" class="flex flex-wrap gap-2 ml-11">
                  <div *ngFor="let action of sub.actions; let ai = index"
                    (click)="toggleSectionSubPermission(mi, secIdx, si, ai)"
                    class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium cursor-pointer transition-all border"
                    [class]="action.enabled
                      ? 'border-green-300 bg-green-50 text-green-800 hover:bg-green-100'
                      : 'border-gray-200 bg-gray-50 text-gray-400 hover:bg-gray-100 line-through'">
                    <i [class]="action.icon" class="text-[10px]"></i>
                    {{ action.name }}
                  </div>
                </div>
                <div *ngIf="sub.subStatus === 'denied'" class="flex flex-wrap gap-2 ml-11 opacity-40">
                  <div *ngFor="let action of sub.actions"
                    class="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium border border-gray-200 bg-gray-50 text-gray-400 line-through">
                    <i [class]="action.icon" class="text-[10px]"></i>
                    {{ action.name }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Barra de guardar cambios -->
    <div *ngIf="selectedRoleForMatrix && matrixDirty"
      class="sticky bottom-0 mt-4 p-4 rounded-lg border-2 border-orange-300 bg-orange-50 flex items-center justify-between shadow-lg z-10">
      <div class="flex items-center gap-2">
        <i class="fas fa-exclamation-triangle text-orange-500"></i>
        <span class="text-sm font-medium text-orange-800">Tienes cambios sin guardar en los permisos de <strong>{{ selectedRoleForMatrix }}</strong></span>
      </div>
      <div class="flex items-center gap-2">
        <button (click)="onRoleSelectForMatrix()"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-gray-300 bg-white hover:bg-gray-50 h-9 px-4 transition-colors">
          <i class="fas fa-undo mr-2"></i>Descartar
        </button>
        <button (click)="saveMatrixPermissions()" [disabled]="savingMatrix"
          class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-green-600 text-white hover:bg-green-700 h-9 px-6 disabled:opacity-50 transition-colors">
          <i class="fas fa-save mr-2" *ngIf="!savingMatrix"></i>
          <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingMatrix"></i>
          Guardar Cambios
        </button>
      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!selectedRoleForMatrix" class="py-16 text-center text-gray-400">
      <i class="fas fa-key text-5xl mb-4 opacity-30"></i>
      <p class="text-lg">Seleccione un rol para ver y configurar sus permisos</p>
      <p class="text-sm mt-1">La matriz muestra los {{ stats.totalModules }} módulos y {{ stats.totalSubmodules }} submódulos del sistema con sus acciones por rol</p>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB 7: AGREGAR PERMISOS                -->
  <!--  Se monta al abrir la pestaña por primera vez y se queda oculto al salir, para no perder lo marcado. -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && puedeAgregarPermisos && agregarVisitada" [hidden]="activeTab !== 'agregar'">
    <app-agregar-permisos (guardado)="alGuardarPermisos()" (verEnMatriz)="verAgregadosEnMatriz()"></app-agregar-permisos>
  </div>

  <!-- Organizar la matriz: cada cambio guardado recarga la matriz -->
  <div *ngIf="!loading && puedeAgregarPermisos && organizarVisitada" [hidden]="activeTab !== 'organizar'">
    <app-organizar-matriz (guardado)="alGuardarPermisos()"></app-organizar-matriz>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  TAB 5: AUDITORÍA                       -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="!loading && activeTab === 'audit'">
    <!-- Filtros -->
    <div class="rounded-lg border bg-card text-card-foreground shadow-sm mb-4">
      <div class="p-4">
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
          <div>
            <label class="text-xs font-medium text-gray-500 mb-1 block">Acción</label>
            <select [(ngModel)]="auditFilter" (change)="onAuditFilterChange()"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
              <option value="all">Todas las acciones</option>
              <option value="ASSIGN">Asignación de rol</option>
              <option value="REVOKE">Remoción de rol</option>
              <option value="CREATE">Creación</option>
              <option value="UPDATE">Actualización</option>
              <option value="DELETE">Eliminación</option>
              <option value="ACTIVATE">Activación</option>
              <option value="DEACTIVATE">Desactivación</option>
            </select>
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 mb-1 block">Entidad</label>
            <select [(ngModel)]="auditEntityFilter" (change)="onAuditFilterChange()"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
              <option value="all">Todas</option>
              <option value="USER">Usuarios</option>
              <option value="ROLE">Roles</option>
              <option value="USER_ROLE_ASSIGNMENT">Asignaciones</option>
              <option value="ROLE_PERMISSION">Permisos de rol</option>
            </select>
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 mb-1 block">Desde</label>
            <input type="date" [(ngModel)]="auditDateFrom" (change)="onAuditFilterChange()"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
          </div>
          <div>
            <label class="text-xs font-medium text-gray-500 mb-1 block">Hasta</label>
            <input type="date" [(ngModel)]="auditDateTo" (change)="onAuditFilterChange()"
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
          </div>
        </div>
        <div class="flex items-center gap-3 mt-3">
          <div class="flex-1 relative">
            <input type="text" [(ngModel)]="auditSearch" (keyup.enter)="onAuditFilterChange()"
              placeholder="Buscar por nombre de usuario..."
              class="flex h-9 w-full rounded-md border border-input bg-background px-3 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-ring">
            <i class="fas fa-search absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-xs"></i>
          </div>
          <button (click)="onAuditFilterChange()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-4 transition-colors">
            <i class="fas fa-search mr-1"></i>Buscar
          </button>
          <span class="text-xs text-gray-500">{{ auditTotal }} evento{{ auditTotal !== 1 ? 's' : '' }}</span>
        </div>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loadingAudit" class="py-12 text-center">
      <i class="fas fa-spinner fa-spin text-2xl text-blue-500"></i>
      <p class="mt-2 text-sm text-gray-500">Cargando eventos de auditoría...</p>
    </div>

    <!-- Timeline -->
    <div *ngIf="!loadingAudit" class="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div class="p-6">
        <div class="space-y-4">
          <div *ngFor="let log of auditLogs" class="flex gap-4 p-3 rounded-lg hover:bg-muted/50 transition-colors">
            <div class="flex-shrink-0 w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center">
              <i [class]="getAuditIcon(log.action)" [ngClass]="getAuditColor(log.action)"></i>
            </div>
            <div class="flex-1 min-w-0">
              <div class="flex items-center gap-2 mb-1">
                <span class="font-medium text-sm">{{ getAuditDetail(log) }}</span>
                <span class="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold"
                  [ngClass]="{
                    'bg-green-100 text-green-800': log.status === 'SUCCESS',
                    'bg-red-100 text-red-800': log.status === 'FAILURE',
                    'bg-yellow-100 text-yellow-800': log.status === 'WARNING'
                  }">{{ getAuditStatusLabel(log.status) }}</span>
              </div>
              <div class="flex flex-wrap items-center gap-3 text-xs text-gray-500">
                <span><i class="fas fa-user mr-1"></i>{{ log.userName || 'Sistema' }}</span>
                <span class="inline-flex items-center rounded px-1.5 py-0.5 bg-gray-100 text-gray-600 text-[10px]">{{ getAuditActionLabel(log.action) }}</span>
                <span class="inline-flex items-center rounded px-1.5 py-0.5 bg-blue-50 text-blue-600 text-[10px]">{{ getAuditEntityLabel(log.entity) }}</span>
                <span><i class="fas fa-clock mr-1"></i>{{ log.timestamp | date:'dd/MM/yyyy HH:mm:ss' }}</span>
                <span *ngIf="log.ipAddress"><i class="fas fa-globe mr-1"></i>{{ log.ipAddress }}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="auditLogs.length === 0" class="py-12 text-center text-gray-400">
          <i class="fas fa-history text-4xl mb-3"></i>
          <p class="text-sm">No hay eventos de auditoría</p>
          <p class="text-xs mt-1">Los eventos se registran automáticamente al realizar acciones en el sistema</p>
        </div>
      </div>

      <!-- Paginación -->
      <div *ngIf="auditTotalPages > 1" class="flex items-center justify-between px-4 py-3 border-t">
        <div class="text-xs text-gray-500">
          Página {{ auditPage }} de {{ auditTotalPages }}
        </div>
        <div class="flex items-center gap-1">
          <button (click)="goToAuditPage(auditPage - 1)" [disabled]="auditPage === 1"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-left"></i>
          </button>
          <button (click)="goToAuditPage(auditPage + 1)" [disabled]="auditPage === auditTotalPages"
            class="inline-flex items-center justify-center rounded-md text-xs h-8 w-8 border border-input bg-background hover:bg-accent disabled:opacity-40 transition-colors">
            <i class="fas fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  LOADING INICIAL                        -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="loading" class="flex items-center justify-center py-20">
    <div class="text-center">
      <i class="fas fa-spinner fa-spin text-4xl text-gray-400 mb-4"></i>
      <p class="text-gray-500">Cargando datos RBAC...</p>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Gestionar Roles (Modo Batch)    -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showAssignModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeAssignModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 z-10 max-h-[80vh] overflow-y-auto">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-user-cog mr-2 text-blue-600"></i>Gestionar Roles</h3>
          <button (click)="closeAssignModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4 p-3 rounded-lg bg-gray-50">
          <p class="text-sm font-medium text-capitalize">{{ selectedUser?.name }} {{ selectedUser?.lastName }}</p>
          <p class="text-xs text-gray-500">{{ selectedUser?.username }}</p>
        </div>

        <!-- Roles en staging (vista previa) -->
        <div class="mb-4">
          <label class="text-sm font-medium leading-none mb-2 block">Roles Asignados</label>
          <div *ngIf="stagedRoles.length > 0" class="space-y-2">
            <div *ngFor="let role of stagedRoles; let i = index"
              class="flex items-center justify-between p-2.5 rounded-lg border bg-gray-50 border-gray-200">
              <div class="flex items-center gap-2">
                <i class="fas fa-shield-alt text-blue-400 text-xs"></i>
                <div>
                  <span class="text-sm font-medium">{{ role.name }}</span>
                  <div class="text-xs text-gray-400">{{ role.department }}</div>
                </div>
              </div>
              <button type="button" (click)="removeStagedRole(role.code)"
                class="text-red-500 hover:text-red-700 text-xs px-2 py-1 rounded hover:bg-red-50 transition-colors"
                title="Quitar este rol">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>
          <div *ngIf="stagedRoles.length === 0" class="p-3 text-center text-gray-400 text-sm border rounded-lg border-dashed">
            <i class="fas fa-info-circle mr-1"></i>Sin roles asignados
          </div>
          <p *ngIf="stagedRoles.length > 0" class="text-xs text-blue-600 mt-2">
            <i class="fas fa-shield-alt mr-1"></i>Los permisos del usuario serán la unión de todos los roles asignados
          </p>
        </div>

        <!-- Agregar nuevo rol -->
        <div class="mb-4 pt-3 border-t">
          <label class="text-sm font-medium leading-none mb-2 block">Agregar Rol</label>
          <div class="flex gap-2">
            <select [(ngModel)]="selectedRoleCode"
              class="flex h-10 flex-1 rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
              <option value="">-- Seleccionar rol --</option>
              <option *ngFor="let role of getAvailableRolesForUser()" [value]="role.code">
                {{ role.name }} — {{ role.department }}
              </option>
            </select>
            <button type="button" (click)="addRoleToStaging()" [disabled]="!selectedRoleCode"
              class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-4 py-2 disabled:opacity-50 transition-colors whitespace-nowrap">
              <i class="fas fa-plus mr-1"></i>Agregar
            </button>
          </div>
        </div>

        <!-- Indicador de cambios pendientes -->
        <div *ngIf="hasRoleChanges" class="mb-3 p-2 rounded-lg bg-yellow-50 border border-yellow-200 text-center">
          <span class="text-xs text-yellow-700"><i class="fas fa-exclamation-circle mr-1"></i>Hay cambios sin aplicar</span>
        </div>

        <div class="flex gap-2 justify-end pt-3 border-t">
          <button *ngIf="stagedRoles.length > 0" type="button" (click)="clearStagedRoles()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-red-300 text-red-600 hover:bg-red-50 h-10 px-4 py-2 transition-colors">
            <i class="fas fa-trash mr-2"></i>Revocar Todos
          </button>
          <button type="button" (click)="closeAssignModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button type="button" (click)="applyRoleChanges()" [disabled]="!hasRoleChanges || saving"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-green-600 text-white hover:bg-green-700 h-10 px-4 py-2 disabled:opacity-50 transition-colors">
            <i class="fas fa-check mr-2" *ngIf="!saving"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="saving"></i>
            Aceptar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Permisos del Rol                -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showPermissionsModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closePermissionsModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 z-10 max-h-[80vh] overflow-y-auto">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <div>
            <h3 class="text-lg font-semibold">{{ selectedRoleForPermissions?.name }}</h3>
            <p class="text-sm text-gray-500">{{ selectedRoleForPermissions?.department }}</p>
          </div>
          <button (click)="closePermissionsModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div *ngIf="loadingPermissions" class="py-8 text-center">
          <i class="fas fa-spinner fa-spin text-2xl text-gray-400"></i>
          <p class="mt-2 text-sm text-gray-500">Cargando permisos...</p>
        </div>

        <div *ngIf="!loadingPermissions">
          <p class="text-sm text-gray-600 mb-4">
            <i class="fas fa-key mr-1"></i>{{ rolePermissions?.permissionsCount || rolePermissions?.permissions?.length || 0 }} permisos configurados
          </p>

          <div *ngFor="let perm of rolePermissions?.permissions || []" class="mb-3">
            <h4 class="text-sm font-semibold text-gray-700 mb-1.5 capitalize">
              <i class="fas fa-folder mr-1 text-indigo-500"></i>{{ perm.module }} → {{ perm.submodule }}
            </h4>
            <div class="flex flex-wrap gap-1 ml-5">
              <span *ngFor="let action of perm.actions"
                class="inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium"
                [ngClass]="getActionColorClass(getActionLabel(action).color)">
                <i [class]="getActionLabel(action).icon + ' mr-1 text-[10px]'"></i>{{ getActionLabel(action).name }}
              </span>
            </div>
          </div>

          <div *ngIf="!rolePermissions?.permissions?.length" class="py-4 text-center text-gray-400">
            <i class="fas fa-info-circle mr-1"></i>No hay permisos configurados para este rol.
            <br>
            <span class="text-xs">Configura permisos desde la Matriz de Permisos.</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Detalle de Usuario (Roles + Permisos) -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showUserDetailModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeUserDetailModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-2xl mx-4 z-10 max-h-[85vh] overflow-y-auto">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-user-shield mr-2 text-indigo-600"></i>Detalle de Usuario</h3>
          <button (click)="closeUserDetailModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div *ngIf="loadingUserDetail" class="py-12 text-center">
          <i class="fas fa-spinner fa-spin text-2xl text-gray-400"></i>
          <p class="mt-2 text-sm text-gray-500">Cargando roles y permisos...</p>
        </div>

        <div *ngIf="!loadingUserDetail && userDetailData">
          <!-- Info del usuario -->
          <div class="mb-4 p-3 rounded-lg bg-gray-50">
            <p class="text-sm font-medium text-capitalize">{{ userDetailData.user?.name }} {{ userDetailData.user?.lastName }}</p>
            <p class="text-xs text-gray-500">{{ userDetailData.user?.username }}</p>
            <div class="flex flex-wrap gap-3 mt-2 text-xs text-gray-500">
              <span *ngIf="userDetailData.user?.email"><i class="fas fa-envelope mr-1"></i>{{ userDetailData.user?.email }}</span>
              <span *ngIf="userDetailData.user?.phone"><i class="fas fa-phone mr-1"></i>{{ userDetailData.user?.phone }}</span>
            </div>
          </div>

          <!-- Info de inactivacion (solo si esta inactivo) -->
          <div *ngIf="userDetailData.user?.status === false" class="mb-5 p-3 rounded-lg bg-red-50 border border-red-200">
            <h4 class="text-sm font-semibold mb-2 text-red-700"><i class="fas fa-ban mr-1"></i>Usuario Inactivo</h4>
            <div class="text-xs text-red-700 space-y-1">
              <div *ngIf="userDetailData.user?.deactivationReason">
                <span class="font-semibold">Motivo:</span>
                <span class="ml-1">{{ getDeactivationReasonLabel(userDetailData.user.deactivationReason) }}</span>
              </div>
              <div *ngIf="userDetailData.user?.deactivationNote">
                <span class="font-semibold">Descripcion:</span>
                <span class="ml-1">{{ userDetailData.user.deactivationNote }}</span>
              </div>
              <div *ngIf="userDetailData.user?.deactivationDate">
                <span class="font-semibold">Fecha:</span>
                <span class="ml-1">{{ userDetailData.user.deactivationDate | date:'dd/MM/yyyy HH:mm' }}</span>
              </div>
              <div *ngIf="!userDetailData.user?.deactivationReason && !userDetailData.user?.deactivationNote" class="italic">
                Sin informacion de inactivacion registrada
              </div>
            </div>
          </div>

          <!-- Roles asignados -->
          <div class="mb-5">
            <h4 class="text-sm font-semibold mb-2"><i class="fas fa-shield-alt mr-1 text-blue-600"></i>Roles Asignados ({{ userDetailData.roles?.length || 0 }})</h4>
            <div *ngIf="userDetailData.roles?.length > 0" class="space-y-2">
              <div *ngFor="let role of userDetailData.roles; let i = index"
                class="flex items-center gap-3 p-2.5 rounded-lg border bg-gray-50 border-gray-200">
                <i class="fas fa-shield-alt text-blue-400 text-xs"></i>
                <div>
                  <span class="text-sm font-medium">{{ role.name }}</span>
                  <span class="text-xs text-gray-500 ml-1">({{ role.code }})</span>
                  <div class="text-xs text-gray-400">{{ role.department }}</div>
                </div>
              </div>
            </div>
            <div *ngIf="!userDetailData.roles?.length" class="p-3 text-center text-gray-400 text-sm border rounded-lg border-dashed">
              Sin roles asignados
            </div>
          </div>

          <!-- Permisos especiales: se activan usuario por usuario, sin importar el rol -->
          <div class="mb-5" *ngIf="individualCatalog.length > 0 && userDetailTarget">
            <h4 class="text-sm font-semibold mb-1"><i class="fas fa-user-lock mr-1 text-purple-600"></i>Permisos especiales</h4>
            <p class="text-xs text-gray-500 mb-2">Se activan solo para este usuario, sin importar su rol. Aplican cuando vuelve a iniciar sesión (o en unos minutos).</p>
            <div class="space-y-2">
              <div *ngFor="let perm of individualCatalog" class="flex items-center justify-between gap-3 p-2.5 rounded-lg border bg-gray-50 border-gray-200">
                <div>
                  <div class="text-sm font-medium">{{ perm.name }}</div>
                  <div class="text-xs text-gray-500">{{ perm.description }}</div>
                </div>
                <button type="button" role="switch" [attr.aria-checked]="hasIndividual(userDetailTarget, perm.code)"
                  (click)="toggleIndividual(userDetailTarget, perm)"
                  [disabled]="!!savingIndividual || !_auth.hasPermission('config.roles_permisos.update')"
                  [title]="hasIndividual(userDetailTarget, perm.code) ? 'Activado — clic para desactivar' : 'Desactivado — clic para activar'"
                  class="relative inline-flex h-6 w-11 flex-shrink-0 items-center rounded-full transition-colors disabled:opacity-50"
                  [ngClass]="hasIndividual(userDetailTarget, perm.code) ? 'bg-green-500' : 'bg-gray-300'">
                  <span class="inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform"
                    [ngClass]="hasIndividual(userDetailTarget, perm.code) ? 'translate-x-5' : 'translate-x-0.5'"></span>
                </button>
              </div>
            </div>
          </div>

          <!-- Permisos efectivos -->
          <div>
            <h4 class="text-sm font-semibold mb-2"><i class="fas fa-key mr-1 text-green-600"></i>Permisos Efectivos</h4>
            <div *ngIf="userDetailData.permissionsByModule && getObjectKeys(userDetailData.permissionsByModule).length > 0">
              <div *ngFor="let module of getObjectKeys(userDetailData.permissionsByModule)" class="mb-3">
                <h5 class="text-xs font-semibold text-indigo-700 uppercase mb-1.5">
                  <i class="fas fa-folder mr-1"></i>{{ module }}
                </h5>
                <div *ngFor="let sub of getObjectKeys(userDetailData.permissionsByModule[module])" class="ml-4 mb-1.5">
                  <span class="text-xs text-gray-600 font-medium">{{ sub }}:</span>
                  <div class="flex flex-wrap gap-1 mt-0.5">
                    <span *ngFor="let action of userDetailData.permissionsByModule[module][sub]"
                      class="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium"
                      [ngClass]="getActionColorClass(getActionLabel(action).color)">
                      <i [class]="getActionLabel(action).icon + ' mr-0.5 text-[8px]'"></i>{{ getActionLabel(action).name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!userDetailData.permissionsByModule || getObjectKeys(userDetailData.permissionsByModule).length === 0"
              class="p-3 text-center text-gray-400 text-sm border rounded-lg border-dashed">
              Sin permisos efectivos
            </div>
          </div>
        </div>

        <div *ngIf="!loadingUserDetail && !userDetailData" class="py-8 text-center text-gray-400">
          <i class="fas fa-exclamation-circle text-2xl mb-2"></i>
          <p class="text-sm">No se pudieron cargar los datos del usuario</p>
        </div>

        <div class="flex justify-end mt-4 pt-3 border-t">
          <button (click)="closeUserDetailModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Crear Nuevo Rol                 -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showCreateRoleModal" class="fixed inset-0 z-50 flex items-start justify-center pt-8 pb-8">
    <div class="fixed inset-0 bg-black/50" (click)="closeCreateRoleModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-4xl mx-4 z-10 max-h-[90vh] overflow-y-auto">
      <div class="p-6">
        <!-- Header -->
        <div class="flex items-center justify-between mb-6">
          <div>
            <h3 class="text-xl font-bold"><i class="fas fa-plus-circle mr-2 text-blue-600"></i>Crear Nuevo Rol</h3>
            <p class="text-sm text-gray-500 mt-1">Define los datos del rol y asigna los permisos por módulo</p>
          </div>
          <button (click)="closeCreateRoleModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times text-lg"></i>
          </button>
        </div>

        <!-- Formulario datos del rol -->
        <div class="rounded-lg border p-4 mb-6 bg-gray-50">
          <h4 class="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">Datos del Rol</h4>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label class="text-sm font-medium mb-1 block">Nombre del Rol <span class="text-red-500 font-bold">*</span></label>
              <input type="text" [(ngModel)]="newRole.name" (blur)="onNewRoleNameChange()"
                placeholder="Ej: Analista de Ventas"
                class="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            </div>
            <div>
              <label class="text-sm font-medium mb-1 block">Código (UPPER_SNAKE_CASE) <span class="text-red-500 font-bold">*</span></label>
              <input type="text" [(ngModel)]="newRole.code"
                placeholder="Ej: ANALISTA_VENTAS"
                class="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            </div>
            <div>
              <label class="text-sm font-medium mb-1 block">Departamento <span class="text-red-500 font-bold">*</span></label>
              <select [(ngModel)]="newRole.department"
                class="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                <option value="">-- Seleccione --</option>
                <option *ngFor="let dept of departments" [value]="dept">{{ dept }}</option>
              </select>
            </div>
            <div>
              <label class="text-sm font-medium mb-1 block">Descripción</label>
              <input type="text" [(ngModel)]="newRole.description"
                placeholder="Descripción breve del rol"
                class="flex h-10 w-full rounded-md border border-input bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            </div>
          </div>
        </div>

        <!-- Matriz de permisos para el nuevo rol -->
        <div class="mb-6">
          <h4 class="text-sm font-semibold text-gray-700 mb-3 uppercase tracking-wider">
            <i class="fas fa-key mr-1"></i>Permisos del Rol
          </h4>
          <div class="mb-3">
            <label class="text-sm font-medium mb-1 block">Empezar desde otro rol (opcional)</label>
            <select [(ngModel)]="plantillaRolCode" (change)="onPlantillaRolChange()"
              class="flex h-10 w-full md:w-96 rounded-md border border-input bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
              <option value="">-- Ninguno (todo desmarcado) --</option>
              <option *ngFor="let r of roles" [value]="r.code">{{ r.name }} ({{ r.code }})</option>
            </select>
            <p class="mt-1 text-xs text-gray-500">Copia las casillas de ese rol como punto de partida; puedes cambiarlas antes de guardar.</p>
          </div>
          <div class="space-y-2">
            <div *ngFor="let entry of newRolePermissionsMatrix; let mi = index"
              class="rounded-lg border overflow-hidden">
              <!-- Module header -->
              <div class="p-3 flex items-center justify-between transition-colors"
                [class]="newRoleExpandedModules[entry.module.id] ? 'bg-blue-50' : 'bg-white hover:bg-gray-50'">
                <div class="flex items-center gap-2 cursor-pointer flex-1" (click)="toggleNewRoleModuleExpand(entry.module.id)">
                  <i [class]="entry.module.icon + ' text-sm'" [class.text-blue-600]="entry.moduleStatus !== 'denied'" [class.text-gray-400]="entry.moduleStatus === 'denied'"></i>
                  <span class="text-sm font-medium">{{ entry.module.name }}</span>
                  <span *ngIf="entry.moduleStatus === 'all'" class="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium bg-green-100 text-green-800">Completo</span>
                  <span *ngIf="entry.moduleStatus === 'partial'" class="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium bg-yellow-100 text-yellow-800">Parcial</span>
                </div>
                <div class="flex items-center gap-2">
                  <button (click)="toggleNewRoleModule(mi); $event.stopPropagation()"
                    class="relative inline-flex h-5 w-9 items-center rounded-full transition-colors"
                    [class]="entry.moduleStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'">
                    <span class="inline-block h-3 w-3 transform rounded-full bg-white shadow-sm transition-transform"
                      [class]="entry.moduleStatus !== 'denied' ? 'translate-x-5' : 'translate-x-1'"></span>
                  </button>
                  <i (click)="toggleNewRoleModuleExpand(entry.module.id)" class="fas fa-chevron-down text-xs text-gray-400 cursor-pointer transition-transform" [class.rotate-180]="newRoleExpandedModules[entry.module.id]"></i>
                </div>
              </div>
              <!-- Submodules -->
              <div *ngIf="newRoleExpandedModules[entry.module.id]" class="border-t">
                <div *ngFor="let sub of entry.submodules; let si = index"
                  class="border-b last:border-b-0 px-4 py-2"
                  [class]="sub.subStatus === 'denied' ? 'bg-gray-50' : 'bg-white'">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center gap-2">
                      <button (click)="toggleNewRoleSubmodule(mi, si)"
                        class="relative inline-flex h-4 w-7 items-center rounded-full transition-colors flex-shrink-0"
                        [class]="sub.subStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'">
                        <span class="inline-block h-2.5 w-2.5 transform rounded-full bg-white shadow-sm transition-transform"
                          [class]="sub.subStatus !== 'denied' ? 'translate-x-3.5' : 'translate-x-0.5'"></span>
                      </button>
                      <span class="text-xs font-medium" [class.text-gray-400]="sub.subStatus === 'denied'">{{ sub.name }}</span>
                    </div>
                    <div *ngIf="sub.subStatus !== 'denied'" class="flex flex-wrap gap-1">
                      <div *ngFor="let action of sub.actions; let ai = index"
                        (click)="toggleNewRoleAction(mi, si, ai)"
                        class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium cursor-pointer transition-all border"
                        [class]="action.enabled
                          ? 'border-green-300 bg-green-50 text-green-700'
                          : 'border-gray-200 bg-gray-50 text-gray-400'">
                        <i [class]="action.icon" class="text-[8px]"></i>
                        {{ action.name }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- Sections in create role modal -->
                <div *ngFor="let sec of entry.sections; let secIdx = index" class="border-b last:border-b-0">
                  <div class="cursor-pointer px-4 py-2 flex items-center justify-between transition-colors border-t"
                    [class]="isSectionExpanded('new_' + sec.id) ? 'bg-indigo-50' : 'bg-gray-50 hover:bg-gray-100'">
                    <div class="flex items-center gap-2 flex-1" (click)="toggleSectionExpand('new_' + sec.id)">
                      <i [class]="sec.icon + ' text-xs'" [class.text-indigo-600]="sec.sectionStatus !== 'denied'" [class.text-gray-400]="sec.sectionStatus === 'denied'"></i>
                      <span class="text-xs font-semibold">{{ sec.name }}</span>
                      <span *ngIf="sec.sectionStatus === 'all'" class="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium bg-green-100 text-green-800">Completo</span>
                      <span *ngIf="sec.sectionStatus === 'partial'" class="inline-flex items-center rounded-full px-1.5 py-0.5 text-[10px] font-medium bg-yellow-100 text-yellow-800">Parcial</span>
                    </div>
                    <div class="flex items-center gap-2">
                      <button (click)="toggleNewRoleSection(mi, secIdx); $event.stopPropagation()"
                        class="relative inline-flex h-4 w-7 items-center rounded-full transition-colors flex-shrink-0"
                        [class]="sec.sectionStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'">
                        <span class="inline-block h-2.5 w-2.5 transform rounded-full bg-white shadow-sm transition-transform"
                          [class]="sec.sectionStatus !== 'denied' ? 'translate-x-3.5' : 'translate-x-0.5'"></span>
                      </button>
                      <i (click)="toggleSectionExpand('new_' + sec.id)" class="fas fa-chevron-down text-[10px] text-gray-400 cursor-pointer transition-transform" [class.rotate-180]="isSectionExpanded('new_' + sec.id)"></i>
                    </div>
                  </div>
                  <div *ngIf="isSectionExpanded('new_' + sec.id)">
                    <div *ngFor="let sub of sec.submodules; let si = index"
                      class="border-b last:border-b-0 px-6 py-2"
                      [class]="sub.subStatus === 'denied' ? 'bg-gray-50' : 'bg-white'">
                      <div class="flex items-center justify-between">
                        <div class="flex items-center gap-2">
                          <button (click)="toggleNewRoleSectionSubmodule(mi, secIdx, si)"
                            class="relative inline-flex h-4 w-7 items-center rounded-full transition-colors flex-shrink-0"
                            [class]="sub.subStatus !== 'denied' ? 'bg-green-500' : 'bg-gray-300'">
                            <span class="inline-block h-2.5 w-2.5 transform rounded-full bg-white shadow-sm transition-transform"
                              [class]="sub.subStatus !== 'denied' ? 'translate-x-3.5' : 'translate-x-0.5'"></span>
                          </button>
                          <span class="text-xs font-medium" [class.text-gray-400]="sub.subStatus === 'denied'">{{ sub.name }}</span>
                        </div>
                        <div *ngIf="sub.subStatus !== 'denied'" class="flex flex-wrap gap-1">
                          <div *ngFor="let action of sub.actions; let ai = index"
                            (click)="toggleNewRoleSectionAction(mi, secIdx, si, ai)"
                            class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium cursor-pointer transition-all border"
                            [class]="action.enabled
                              ? 'border-green-300 bg-green-50 text-green-700'
                              : 'border-gray-200 bg-gray-50 text-gray-400'">
                            <i [class]="action.icon" class="text-[8px]"></i>
                            {{ action.name }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Botones -->
        <div class="flex gap-2 justify-end pt-4 border-t">
          <button (click)="closeCreateRoleModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="saveNewRole()" [disabled]="savingRole || !newRole.code || !newRole.name || !newRole.department"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-10 px-6 py-2 disabled:opacity-50 transition-colors">
            <i class="fas fa-check mr-2" *ngIf="!savingRole"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingRole"></i>
            Crear Rol
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Crear Nuevo Usuario             -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showCreateUserModal" class="fixed inset-0 z-50 flex items-start justify-center pt-8 pb-8">
    <div class="fixed inset-0 bg-black/50" (click)="closeCreateUserModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-lg mx-4 z-10 max-h-[90vh] overflow-y-auto">
      <div class="p-6">
        <div class="flex items-center justify-between mb-5">
          <h3 class="text-lg font-semibold"><i class="fas fa-user-plus mr-2 text-green-600"></i>Nuevo Usuario</h3>
          <button (click)="closeCreateUserModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div *ngIf="newUserErrors.length > 0" class="mb-4 p-3 rounded-lg bg-red-50 border border-red-200">
          <div *ngFor="let err of newUserErrors" class="text-sm text-red-700">
            <i class="fas fa-exclamation-circle mr-1"></i>{{ err.msg }}
          </div>
        </div>

        <div class="space-y-4">
          <!-- Datos básicos -->
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="text-sm font-medium mb-1 block">Nombre <span class="text-red-500 font-bold">*</span></label>
              <input type="text" [(ngModel)]="newUser.name" (blur)="onNewUserFieldBlur('name')" (input)="newUserTouched['name'] && validateNewUserField('name')" placeholder="Nombre"
                class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm text-capitalize focus:outline-none focus:ring-2 focus:ring-offset-2"
                [ngClass]="newUserFieldErrors['name'] && newUserTouched['name'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
              <span *ngIf="newUserFieldErrors['name'] && newUserTouched['name']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['name'] }}</span>
            </div>
            <div>
              <label class="text-sm font-medium mb-1 block">Apellido <span class="text-red-500 font-bold">*</span></label>
              <input type="text" [(ngModel)]="newUser.lastName" (blur)="onNewUserFieldBlur('lastName')" (input)="newUserTouched['lastName'] && validateNewUserField('lastName')" placeholder="Apellido"
                class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm text-capitalize focus:outline-none focus:ring-2 focus:ring-offset-2"
                [ngClass]="newUserFieldErrors['lastName'] && newUserTouched['lastName'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
              <span *ngIf="newUserFieldErrors['lastName'] && newUserTouched['lastName']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['lastName'] }}</span>
            </div>
          </div>
          <div>
            <label class="text-sm font-medium mb-1 block">Username <span class="text-red-500 font-bold">*</span></label>
            <input type="text" [(ngModel)]="newUser.username" (blur)="onNewUserFieldBlur('username')" (input)="newUserTouched['username'] && validateNewUserField('username')" placeholder="Minimo 5 caracteres"
              class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
              [ngClass]="newUserFieldErrors['username'] && newUserTouched['username'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
            <span *ngIf="newUserFieldErrors['username'] && newUserTouched['username']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['username'] }}</span>
            <span *ngIf="!newUserFieldErrors['username'] || !newUserTouched['username']" class="text-xs text-gray-400">Minimo 5 caracteres alfanumericos (. _ - permitidos)</span>
          </div>
          <div>
            <label class="text-sm font-medium mb-1 block">Contraseña <span class="text-red-500 font-bold">*</span></label>
            <div class="relative">
              <input [type]="showNewUserPassword ? 'text' : 'password'" [(ngModel)]="newUser.password" (blur)="onNewUserFieldBlur('password')" (input)="newUserTouched['password'] && validateNewUserField('password')" placeholder="6-12 caracteres" maxlength="12"
                class="flex h-10 w-full rounded-md border bg-background px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
                [ngClass]="newUserFieldErrors['password'] && newUserTouched['password'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
              <button type="button" (click)="showNewUserPassword = !showNewUserPassword"
                class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                <i [class]="showNewUserPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
            </div>
            <span *ngIf="newUserFieldErrors['password'] && newUserTouched['password']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['password'] }}</span>
            <span *ngIf="!newUserFieldErrors['password'] || !newUserTouched['password']" class="text-xs text-gray-400">6-12 caracteres con mayuscula, minuscula, numero y caracter especial</span>
          </div>

          <!-- Contacto -->
          <div class="grid grid-cols-2 gap-3">
            <div>
              <label class="text-sm font-medium mb-1 block">Correo Electronico</label>
              <input type="email" [(ngModel)]="newUser.email" (blur)="onNewUserFieldBlur('email')" (input)="newUserTouched['email'] && validateNewUserField('email')" placeholder="correo@ejemplo.com"
                class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
                [ngClass]="newUserFieldErrors['email'] && newUserTouched['email'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
              <span *ngIf="newUserFieldErrors['email'] && newUserTouched['email']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['email'] }}</span>
            </div>
            <div>
              <label class="text-sm font-medium mb-1 block">Telefono</label>
              <input type="text" inputmode="numeric" pattern="[0-9]*" [ngModel]="newUser.phone" (input)="onNewUserPhoneInput($event)" (keypress)="onPhoneKeyPress($event)" (paste)="onNewUserPhoneInput($event)" (blur)="onNewUserFieldBlur('phone')" placeholder="04XXXXXXXXX" maxlength="11"
                class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
                [ngClass]="newUserFieldErrors['phone'] && newUserTouched['phone'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
              <span *ngIf="newUserFieldErrors['phone'] && newUserTouched['phone']" class="text-xs text-red-600 mt-1 block">{{ newUserFieldErrors['phone'] }}</span>
            </div>
          </div>

          <!-- Tienda -->
          <div>
            <label class="text-sm font-medium mb-1 block">Tienda</label>
            <select [(ngModel)]="newUser.shop"
              class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
              <option value="">Sin tienda</option>
              <option *ngFor="let shop of shops" [value]="shop.code">{{ shop.name }}</option>
            </select>
          </div>

          <!-- Roles -->
          <div class="pt-3 border-t">
            <label class="text-sm font-medium mb-2 block">Roles RBAC</label>
            <div *ngIf="newUser.roles.length > 0" class="space-y-1.5 mb-3">
              <div *ngFor="let role of newUser.roles"
                class="flex items-center justify-between p-2 rounded-lg border bg-gray-50 border-gray-200">
                <div class="flex items-center gap-2">
                  <i class="fas fa-shield-alt text-blue-400 text-xs"></i>
                  <span class="text-sm font-medium">{{ role.name }}</span>
                  <span class="text-xs text-gray-400">{{ role.department }}</span>
                </div>
                <button type="button" (click)="removeRoleFromNewUser(role.code)"
                  class="text-red-500 hover:text-red-700 text-xs"><i class="fas fa-times"></i></button>
              </div>
            </div>
            <div class="flex gap-2">
              <select [(ngModel)]="newUserSelectedRoleCode"
                class="flex h-9 flex-1 rounded-md border border-input bg-background px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
                <option value="">-- Seleccionar rol --</option>
                <option *ngFor="let role of getAvailableRolesForNewUser()" [value]="role.code">
                  {{ role.name }} — {{ role.department }}
                </option>
              </select>
              <button type="button" (click)="addRoleToNewUser()" [disabled]="!newUserSelectedRoleCode"
                class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 h-9 px-3 disabled:opacity-50 transition-colors">
                <i class="fas fa-plus"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="flex gap-2 justify-end mt-6 pt-4 border-t">
          <button (click)="closeCreateUserModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="createUser()" [disabled]="savingUser || !isNewUserFormValid()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium text-white h-10 px-6 py-2 transition-colors"
            [ngClass]="savingUser || !isNewUserFormValid() ? 'bg-gray-400 cursor-not-allowed' : 'bg-green-600 hover:bg-green-700'">
            <i class="fas fa-check mr-2" *ngIf="!savingUser"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingUser"></i>
            Crear Usuario
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Cambiar Contraseña              -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showPasswordModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closePasswordModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-sm mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-key mr-2 text-orange-500"></i>Cambiar Contraseña</h3>
          <button (click)="closePasswordModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4 p-3 rounded-lg bg-gray-50">
          <p class="text-sm font-medium text-capitalize">{{ passwordUser?.name }} {{ passwordUser?.lastName }}</p>
          <p class="text-xs text-gray-500">{{ passwordUser?.username }}</p>
        </div>

        <div class="mb-4">
          <label class="text-sm font-medium mb-1 block">Nueva Contraseña</label>
          <div class="relative">
            <input [type]="showPasswordValue ? 'text' : 'password'" [(ngModel)]="newPassword" (input)="onPasswordInput()" placeholder="6-12 caracteres" maxlength="12"
              class="flex h-10 w-full rounded-md border bg-background px-3 py-2 pr-10 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
              [ngClass]="passwordError ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
            <button type="button" (click)="showPasswordValue = !showPasswordValue"
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
              <i [class]="showPasswordValue ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
            </button>
          </div>
          <span *ngIf="passwordError" class="text-xs text-red-600 mt-1 block">{{ passwordError }}</span>
          <span *ngIf="!passwordError" class="text-xs text-gray-400 mt-1 block">6-12 caracteres con mayuscula, minuscula, numero y caracter especial</span>
        </div>

        <div class="flex gap-2 justify-end">
          <button (click)="closePasswordModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="changePassword()" [disabled]="savingPassword || !isPasswordValid()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium text-white h-10 px-6 py-2 transition-colors"
            [ngClass]="savingPassword || !isPasswordValid() ? 'bg-gray-400 cursor-not-allowed' : 'bg-orange-500 hover:bg-orange-600'">
            <i class="fas fa-check mr-2" *ngIf="!savingPassword"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingPassword"></i>
            Cambiar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Asignar Tienda                  -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showShopModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeShopModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-sm mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-store mr-2 text-blue-500"></i>Asignar Tienda</h3>
          <button (click)="closeShopModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4 p-3 rounded-lg bg-gray-50">
          <p class="text-sm font-medium text-capitalize">{{ shopUser?.name }} {{ shopUser?.lastName }}</p>
          <p class="text-xs text-gray-500">{{ shopUser?.username }}</p>
        </div>

        <div class="mb-4">
          <label class="text-sm font-medium mb-1 block">Tienda</label>
          <select [(ngModel)]="selectedShopCode"
            class="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2">
            <option value="">Sin tienda</option>
            <option *ngFor="let shop of shops" [value]="shop.code">{{ shop.name }}</option>
          </select>
        </div>

        <div class="flex gap-2 justify-end">
          <button (click)="closeShopModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="changeShop()" [disabled]="savingShop"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium bg-blue-600 text-white hover:bg-blue-700 h-10 px-6 py-2 disabled:opacity-50 transition-colors">
            <i class="fas fa-check mr-2" *ngIf="!savingShop"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingShop"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Desactivar Usuario              -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showDeactivateModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeDeactivateModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-md mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-ban mr-2 text-red-500"></i>Desactivar Usuario</h3>
          <button (click)="closeDeactivateModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4 p-3 rounded-lg bg-gray-50">
          <p class="text-sm font-medium text-capitalize">{{ deactivateUser?.name }} {{ deactivateUser?.lastName }}</p>
          <p class="text-xs text-gray-500">{{ deactivateUser?.username }}</p>
        </div>

        <div class="mb-4">
          <label class="text-sm font-medium mb-1 block">Motivo de la inactivacion <span class="text-red-500 font-bold">*</span></label>
          <select [(ngModel)]="deactivationReason" (change)="onDeactivationReasonChange()"
            class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
            [ngClass]="deactivationErrors['reason'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
            <option value="">-- Seleccionar motivo --</option>
            <option *ngFor="let r of deactivationReasons" [value]="r.value">{{ r.label }}</option>
          </select>
          <span *ngIf="deactivationErrors['reason']" class="text-xs text-red-600 mt-1 block">{{ deactivationErrors['reason'] }}</span>
        </div>

        <div class="mb-4" *ngIf="deactivationReason === 'OTRO'">
          <label class="text-sm font-medium mb-1 block">Describe el motivo <span class="text-red-500 font-bold">*</span></label>
          <textarea [(ngModel)]="deactivationNote" rows="3" placeholder="Describe brevemente el motivo..."
            class="flex w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2 resize-none"
            [ngClass]="deactivationErrors['note'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'"></textarea>
          <span *ngIf="deactivationErrors['note']" class="text-xs text-red-600 mt-1 block">{{ deactivationErrors['note'] }}</span>
        </div>

        <div class="flex gap-2 justify-end">
          <button (click)="closeDeactivateModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="confirmDeactivation()" [disabled]="savingStatus || !deactivationReason || (deactivationReason === 'OTRO' && !deactivationNote.trim())"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium text-white h-10 px-6 py-2 transition-colors"
            [ngClass]="savingStatus || !deactivationReason || (deactivationReason === 'OTRO' && !deactivationNote.trim()) ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'">
            <i class="fas fa-ban mr-2" *ngIf="!savingStatus"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingStatus"></i>
            Inactivar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  MODAL: Editar Contacto                 -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="showEditContactModal" class="fixed inset-0 z-50 flex items-center justify-center">
    <div class="fixed inset-0 bg-black/50" (click)="closeEditContactModal()"></div>
    <div class="relative bg-white rounded-lg shadow-lg w-full max-w-sm mx-4 z-10">
      <div class="p-6">
        <div class="flex items-center justify-between mb-4">
          <h3 class="text-lg font-semibold"><i class="fas fa-address-card mr-2 text-teal-500"></i>Editar Contacto</h3>
          <button (click)="closeEditContactModal()" class="text-gray-400 hover:text-gray-600">
            <i class="fas fa-times"></i>
          </button>
        </div>

        <div class="mb-4 p-3 rounded-lg bg-gray-50">
          <p class="text-sm font-medium text-capitalize">{{ editContactUser?.name }} {{ editContactUser?.lastName }}</p>
          <p class="text-xs text-gray-500">{{ editContactUser?.username }}</p>
        </div>

        <div class="space-y-4 mb-4">
          <div>
            <label class="text-sm font-medium mb-1 block">Correo Electronico</label>
            <input type="email" [(ngModel)]="editContactEmail" (blur)="onEditContactEmailBlur()" placeholder="correo@ejemplo.com"
              class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
              [ngClass]="editContactErrors['email'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
            <span *ngIf="editContactErrors['email']" class="text-xs text-red-600 mt-1 block">{{ editContactErrors['email'] }}</span>
          </div>
          <div>
            <label class="text-sm font-medium mb-1 block">Telefono</label>
            <input type="text" inputmode="numeric" pattern="[0-9]*" [ngModel]="editContactPhone" (input)="onEditContactPhoneInput($event)" (keypress)="onPhoneKeyPress($event)" (paste)="onEditContactPhoneInput($event)" placeholder="04XXXXXXXXX" maxlength="11"
              class="flex h-10 w-full rounded-md border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-offset-2"
              [ngClass]="editContactErrors['phone'] ? 'border-red-500 focus:ring-red-500' : 'border-input focus:ring-ring'">
            <span *ngIf="editContactErrors['phone']" class="text-xs text-red-600 mt-1 block">{{ editContactErrors['phone'] }}</span>
          </div>
        </div>

        <div class="flex gap-2 justify-end">
          <button (click)="closeEditContactModal()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium border border-input bg-background hover:bg-accent h-10 px-4 py-2 transition-colors">
            Cancelar
          </button>
          <button (click)="saveContactInfo()" [disabled]="savingContact || !isEditContactValid()"
            class="inline-flex items-center justify-center rounded-md text-sm font-medium text-white h-10 px-6 py-2 transition-colors"
            [ngClass]="savingContact || !isEditContactValid() ? 'bg-gray-400 cursor-not-allowed' : 'bg-teal-600 hover:bg-teal-700'">
            <i class="fas fa-check mr-2" *ngIf="!savingContact"></i>
            <i class="fas fa-spinner fa-spin mr-2" *ngIf="savingContact"></i>
            Guardar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- ═══════════════════════════════════════ -->
  <!--  DROPDOWN ACCIONES (portal fijo)        -->
  <!-- ═══════════════════════════════════════ -->
  <div *ngIf="activeMenuUser"
    class="fixed z-50 w-52 rounded-lg border border-gray-200 bg-white shadow-xl py-1"
    [style.top.px]="menuPosition.top"
    [style.left.px]="menuPosition.left">
    <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="openAssignModal(activeMenuUser); closeAllMenus()"
      class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 flex items-center gap-3 transition-colors">
      <i class="fas fa-user-cog text-blue-500 w-4 text-center"></i>Gestionar Roles
    </button>
    <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="openShopModal(activeMenuUser); closeAllMenus()"
      class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-indigo-50 hover:text-indigo-700 flex items-center gap-3 transition-colors">
      <i class="fas fa-store text-indigo-500 w-4 text-center"></i>Asignar Tienda
    </button>
    <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="openEditContactModal(activeMenuUser); closeAllMenus()"
      class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-teal-50 hover:text-teal-700 flex items-center gap-3 transition-colors">
      <i class="fas fa-address-card text-teal-500 w-4 text-center"></i>Editar Contacto
    </button>
    <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="openPasswordModal(activeMenuUser); closeAllMenus()"
      class="w-full text-left px-4 py-2.5 text-sm text-gray-700 hover:bg-orange-50 hover:text-orange-700 flex items-center gap-3 transition-colors">
      <i class="fas fa-key text-orange-500 w-4 text-center"></i>Cambiar Contraseña
    </button>
    <div class="border-t border-gray-100 my-1"></div>
    <button data-rbac-permiso="config.roles_permisos.update" *ngIf="_auth.hasPermission('config.roles_permisos.update')" (click)="toggleUserStatus(activeMenuUser); closeAllMenus()"
      [disabled]="savingStatus"
      class="w-full text-left px-4 py-2.5 text-sm flex items-center gap-3 transition-colors"
      [ngClass]="activeMenuUser.status ? 'text-red-600 hover:bg-red-50' : 'text-green-600 hover:bg-green-50'">
      <i [class]="activeMenuUser.status ? 'fas fa-ban w-4 text-center' : 'fas fa-check-circle w-4 text-center'"></i>
      {{ activeMenuUser.status ? 'Desactivar' : 'Activar' }}
    </button>
  </div>
</div>
